import { Field, ErrorMessage } from 'formik';
import React from 'react';
const AgentDetails = (props) => {
    return (
        <div className='accordion-item'>
            <h2 className='accordion-header' id='flush-headingFour'>
                <button
                    className='accordion-button collapsed accordion-title px-3'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#flush-collapseFour'
                    aria-expanded='false'
                    aria-controls='flush-collapseFour'>
                    Agent Details
                </button>
            </h2>
            <div
                id='flush-collapseFour'
                className='accordion-collapse collapse show'
                aria-labelledby='flush-headingFour'
                data-bs-parent='#accordionFlushExample'>
                <div className='accordion-body p-0 px-1 pb-4'>
                    <div className='col-10'>
                        <div className='row m-0 text-start'>
                            
                            <div className='col-4 mb-3'>
                                <label className='form-label text-neutral-800 font-b3 mb-1'>
                                    Agent Details (Optional)
                                </label>
                                <div className='position-relative'>
                                    <span className='float-end position-absolute top-n20 end-0 font-b3 text-neutral-600'>
                                        {props.formikProps.values.assign_agent?.length || 0}/1000
                                    </span>
                                    <Field
                                        as='textarea'
                                        name='assign_agent'
                                        className='form-control font-b2'
                                        rows='4'
                                        maxLength='1000'
                                        placeholder='Enter agent details'
                                        onChange={(e) => {
                                            if (e.target.value.length <= 1000) {
                                                props.formikProps.setFieldValue('assign_agent', e.target.value);
                                            }
                                        }}
                                    />
                                </div>
                                <ErrorMessage
                                    name='assign_agent'
                                    component='div'
                                    className='error-message font-b4 text-error-700'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgentDetails;
